import _get from 'lodash/get'

const config = {
  // Auth Providers
  environment: process.env.REACT_APP_ENV || 'local',
  ptForgotPasswordLink: process.env.REACT_APP_PT_FORGOT_PASSWORD_LINK || '',
  auth: {
    default: process.env.REACT_APP_AUTH_PROVIDER || 'demo',
    providers: {
      rest: {
        url: process.env.REACT_APP_API,
      },
    },
  },
  mst: {
    rest: {
      // url: process.env.REACT_APP_API_MST,
      url: process.env.REACT_APP_API_MST
        ? process.env.REACT_APP_API_MST
        : process.env.REACT_APP_API.replace('/backoffice', ''),
    },
  },
  googleMap: {
    apiKey: process.env.REACT_APP_GOOGLE_MAP_APIKEY,
  },
  // Data Providers
  data: {
    default: process.env.REACT_APP_DATA_PROVIDER || 'demo',
    providers: {
      demo: {
        host: 'https://jsonplaceholder.typicode.com',
      },
    },
  },
  // Assets base urls
  assets: {
    baseUrl: {
      image: process.env.REACT_APP_IMG_BASE_URL,
    },
  },
  langSupports: ['th' /* 'en' */],
  resources: {
    keys: {
      admins: 'admin_management',
      roles: 'role_management',
      'products-tire': 'product_management_tire',
      'products-shock': 'product_management_shock',
      'products-brake': 'product_management_brake',
      'products-lubricant': 'product_management_lubricant',
      'products-battery': 'product_management_battery',
      'products-other': 'product_management_other',
      'hero-banners': 'website_management_homepage_hero_banner',
      'portal-menus': 'website_management_homepage_portal_menu',
      'partner-icons': 'website_management_homepage_partner_icon',
      catalogues: 'website_management_homepage_catalogue',
      'contact-us': 'website_management_contact_us',
      'job-opportunities': 'website_management_job_opportunity',
      promotions: 'promotion_management_promotion',
      'promotions-banners': 'promotion_management_banner',
      services: 'service_management',
      news: 'news_management',
      blogs: 'blog_management',
      'cars-tire': 'master_data_management_cars_tire',
      'cars-brake': 'master_data_management_cars_brake',
      'cars-shock': 'master_data_management_cars_shock',
      'cars-battery': 'master_data_management_cars_battery',
      'brand-tire': 'master_data_management_brand_tire',
      'brand-brake': 'master_data_management_brand_brake',
      'brand-battery': 'master_data_management_brand_battery',
      'brand-shock': 'master_data_management_brand_shock',
      'brand-lubricant': 'master_data_management_brand_lubricant',
      'brand-other': 'master_data_management_brand_other',
      'products-banners': 'website_management_product_service_banner',
      'products-reviews': 'product_review_management',
      csr: 'csr_management',
      'news-blog-section': 'website_management_homepage_news_blog',
      'job-opportunity-banner': 'website_management_job_opportunity_banner',
    },
  },
  pages: {
    keys: {
      profile: 'profile',
      'import-product': 'import-product',
      'import-master-data': 'import-master-data',
      'not-found': 'not-found',
    },
  },
}

export default (key, defaultValue = undefined): string => {
  return _get(config, key, defaultValue)
}
